import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import promiseMiddleWare from 'redux-promise'
import createDebounce from 'redux-debounce'
import { middleware as toastsMiddleware } from '@sketch/toasts/redux'
import documentSidebar from './modules/documentSidebar'
import { IS_EMBEDDED } from '@sketch/constants'

export const INITIALIZE_APP = Symbol('INITIALIZE_APP')

const debounceConfig = {
  simple: {
    wait: 300,
    leading: true,
  },
}

export default function configureStore({
  initialState = { sidebarRightOpen: IS_EMBEDDED ? false : true },
}) {
  const middleware = applyMiddleware(
    createDebounce(debounceConfig),
    promiseMiddleWare,
    thunk,
    toastsMiddleware
  )

  const store = createStore(documentSidebar, initialState, middleware)

  return store
}
